<template>
  <span>

    <b-container fluid>
      <b-row class="table-header">
        <b-col cols="12" offset-lg="6" lg="6" offset-xl="9" xl="3">
          <b-form-group>
            <b-form-input
              ref="search"
              v-model="meta.search"
              :disabled="fetching"
              placeholder="Search name, email or text"
              @keyup.native="search"
              @input="searchChanged"/>
          </b-form-group>
        </b-col>
      </b-row>

      <no-data v-if="noData" message="No suggestions found..."/>

      <b-table
        v-if="data.length"
        ref="table"
        :responsive="true"
        :hover="rowClickEnabled && !fetching"
        :busy="fetching"
        :items="data"
        :fields="formFields"
        :per-page="Number(meta.per_page)"
        :sort-by="meta.order"
        :sort-desc="meta.desc"
        :no-local-sorting="true"
        @sort-changed="sortChanged"
        @row-clicked="rowClicked">

        <template slot="user" slot-scope="data">
          <span class="name">{{ data.value.name }}</span>
          <span>{{ data.value.email }}</span>
          <b-badge v-if="!data.value.is_active" variant="danger">Account Locked</b-badge>
          <b-badge v-if="!data.value.is_confirmed" variant="danger">Not Confirmed</b-badge>
        </template>

        <template slot="sent" slot-scope="data">
          <div class="no-wrap">
            {{ readableDate(data.value) }}
          </div>
        </template>

        <template slot="actions" slot-scope="data">
          <div v-if="view === 'unread'" class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="mark read">
              <b-button
                :disabled="fetching"
                title="mark read"
                variant="outline-secondary"
                @click.stop="markRead(data.item.id)">
                <i class="fas fa-envelope-open"></i>
              </b-button>
            </span>
            <span v-b-tooltip.hover style="display:inline-block" title="delete">
              <b-button
                :disabled="fetching"
                title="archive"
                variant="outline-secondary"
                @click.stop="destroy(data.item.id)">
                <i class="fas fa-trash"></i>
              </b-button>
            </span>
          </div>
          <div v-if="view === 'read'" class="no-wrap">
            <span v-b-tooltip.hover style="display:inline-block" title="mark unread">
              <b-button
                :disabled="fetching"
                title="mark unread"
                variant="outline-secondary"
                @click.stop="markUnread(data.item.id)">
                <i class="fas fa-envelope"></i>
              </b-button>
            </span>
            <span v-b-tooltip.hover style="display:inline-block" title="delete">
              <b-button
                :disabled="fetching"
                title="archive"
                variant="outline-secondary"
                @click.stop="destroy(data.item.id)">
                <i class="fas fa-trash"></i>
              </b-button>
            </span>
          </div>
        </template>

      </b-table>

      <b-row>
        <b-col cols="12">
          <b-pagination
            v-if="data.length"
            :disabled="fetching"
            :value="Number(meta.current_page)"
            :total-rows="Number(meta.total)"
            :per-page="Number(meta.per_page)"
            @change="pageChanged"/>
        </b-col>
      </b-row>

    </b-container>
  </span>
</template>

<script>
import tableMixin from '../../mixins/admin-table'

export default {
  mixins: [tableMixin],
  data () {
    return {
      formFields: [
        { key: 'user', label: 'From', sortable: true },
        { key: 'text', label: 'Text', sortable: false },
        { key: 'sent', label: 'Sent', sortable: true },
        { key: 'actions', label: 'Actions' }
      ],
      namespace: 'suggestions',
      routeParamName: 'suggestion',
      rowClickRoute: 'admin-view-suggestion'
    }
  },
  methods: {
    markRead (id) {
      this.$store.dispatch('suggestions/update', {
        id,
        data: { 'is_active': false }
      })
    },
    markUnread (id) {
      this.$store.dispatch('suggestions/update', {
        id,
        data: { 'is_active': true }
      })
    },
    destroy (id) {
      const accepted = confirm('This will permanently delete this suggestion. Are you sure you want to continue?')

      if (accepted) {
        this.$store.dispatch('suggestions/destroy', id)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/suggestions/table.vue